import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {useUserRecentQueriesStore} from "@/store/AutocompletePopup/UserRecentQueriesStore";
import {inject} from "vue";
import {SmartSearchTranslationsInterface} from "@/core/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClearQueriesButton',
  setup(__props) {

const userRecentQueriesStore = useUserRecentQueriesStore()
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(userRecentQueriesStore).clearQueries()), ["stop"])),
    class: "clear-queries-btn q-btn q-btn-sm"
  }, _toDisplayString(_unref(SmartSearchTranslations).userRecentQueries.clearButton), 1))
}
}

})